export enum CellType {
  DATE = 'date',
  TIME = 'time',
  TEAM = 'team',
  VENUE = 'venue',
  HIGHLIGHT = 'highlight',
  MONTH = 'month',
  NAME = 'name',
  DESCRIPTION = 'description',
  PRICE = 'price',
  ICONS = 'iconsList',
  VARIATION = 'variationsList',
  SIZE_LIST = 'sizesList',
  ADDON = 'addOnsList',
  COLUMN1 = 'column1',
  COLUMN2 = 'column2',
  COLUMN3 = 'column3',
}
